// Personal-app build — demo mode is permanently off.
// Kept as a stub so consumers can `import { isDemoMode }` without editing every file.
// The SAAS fork of this codebase has the full demo interceptor implementation.

export function isDemoMode() { return false; }
export function exitDemo() {}
export function startDemo() {}
export function demoResolve() { return null; }
export const PROFILES = [];
